import { Injectable } from '@angular/core';
import { URL_SERVICIOS, HTTP_OPTIONS } from '../shared/config/config';
import { HttpClient } from '@angular/common/http';
import { PrePricing } from '../interfaces/pre-pricing';
import { DatatableRootObject } from '../interfaces/datatable-root-object';
import { DataTablesResponse } from '../interfaces/datatables-response';
const URL = `${URL_SERVICIOS}PrePricing`;

@Injectable({
  providedIn: 'root'
})
export class PrePricingService {

  constructor(private http: HttpClient) {}

  getPrePricings = () => this.http.get<PrePricing[]>(URL);

  getPrePricing = (id: number) => this.http.get<PrePricing>(`${URL}/${id}`, HTTP_OPTIONS);

  postPrePricing = (prePricing: PrePricing) =>
    this.http.post<PrePricing>(URL, JSON.stringify(prePricing), HTTP_OPTIONS)
}
